/* global axios */
import ApiClient from './ApiClient';

class TalkviaConnectedBankQueriesAPI extends ApiClient {
  constructor() {
    super('talkvia_connected_bank_queries', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  providers() {
    return axios.get(`${this.url}/providers`);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  continueResult(batchId, resultId, data) {
    return axios.post(`${this.url}/${batchId}/results/${resultId}/continue`, {
      data,
    });
  }
}

export default new TalkviaConnectedBankQueriesAPI();
